import { Grid, Typography } from "@mui/material";

const Teaching = () => {
    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant='h4' sx={{mb: 0, color: '#378dab'}}>
                    Teaching Experiences
                </Typography>
            </Grid>        
            
            <Grid item xs={12}>
                <ul style={{fontStyle: 'italic'}}>
                    <li><b>CS 5305</b> - Teaching Assistant (TXST, Fall 2023)</li>
                    <li><b>CS 5305</b> - Teaching Assistant (TXST, Spring 2023)</li>
                    <li><b>CS 4328</b> - Teaching Assistant (TXST, Spring 2023)</li>                                        
                    <li><b>Introduction to Python Programming Language</b> - Instructor (Online, Spring 2020)</li>                                        
                    <li><b>Algorithm Design</b> - Teaching Assistant (Bu-Ali Sina University, Spring 2019)</li>                                        
                    <li><b>Advanced Programming</b> - Teaching Assistant (Bu-Ali Sina University, Fall 2017)</li>                                        
                </ul>
            </Grid>           
        </Grid>
    )
};

export default Teaching;